<template>
<q-page class="main">
  <common-form :action="$route('category.update', {categorie: category.id})" is-update>
    <q-card class="page-card">
      <q-card-section class="page-card__main-content">
        <item-header :item="category" />
        <category-form :category="category" />
      </q-card-section>
      <q-separator />
      <q-card-actions align="right" class="q-pa-md">
        <accent-button label="Opslaan" type="submit" />
      </q-card-actions>
    </q-card>
  </common-form>
  <q-card class="page-card">
    <q-card-section class="page-card__details">
      <expansion-element
          label="Subcategorieën"
          :items-count="category.subcategories.length">
        <div v-if="category.subcategories.length" class="row q-gutter-x-sm q-gutter-y-md wrap">
          <common-chip
              v-for="subCategory in category.subcategories"
              :key="subCategory.id"
              :label="subCategory.title"
              :link="$route('category.subcategory.edit', { category: category.id, subcategorie: subCategory.id })"
          />
        </div>
        <template v-slot:actions>
          <flat-button label="Nieuwe subcategorie toevoegen" icon="edit"
                       @click="$goto('category.subcategory.create', { category: category.id })" />
        </template>
      </expansion-element>
      <expansion-element
          label="Richtlijnen in deze categorie:"
          :items-count="rules.length"
      >
        <rule-list :items="rules" :category="category" />
      </expansion-element>
      <div v-if="!rules.length" class="row items-center q-gutter-md"
           :class="$isDesktop ? 'justify-between' : 'justify-end'">
        <span class="col-shrink">Deze categorie is leeg.</span>
        <warning-button v-if="category.id == 1" label="Verwijder deze categorie" class="col-shrink"
                        @click="deleteIntegralCategory" />
        <warning-button v-else label="Verwijder deze categorie" class="col-shrink" @click=" deleteCategory" />
      </div>
    </q-card-section>
  </q-card>
  <sticky-top-bar />
</q-page>
</template>

<script>
import RuleList from "~HIOR/components/lists/RuleList"
import CategoryForm from "./CategoryForm"
import ChipList from "~HIOR/components/lists/ChipList"

export default {
  components: {
    RuleList,
    CategoryForm,
    ChipList,
  },
  props: {
    category: {
      type: Object,
      default: null,
    },
    rules: {
      type: Array,
      default: () => [],
    },
  },
  data () {
    return {
      showDialog: false,
    }
  },
  methods: {
    async deleteCategory () {
      if (!await this.$confirm(
          {
            title: "Verwijder categorie",
            messages: ["Weet u zeker dat u deze categorie wil verwijderen?"],
          },
      )) {
        return
      }
      this.$goto("category.destroy", { category_id: this.category.id })
    },
    async deleteIntegralCategory () {
      if (!await this.$confirm(
          {
            title: "Integrale richtlijnen categorie verwijderen",
            messages: ["Weet u zeker dat u de integrale richtlijnen categorie wilt verwijderen? Deze categorie en de " +
            "werking daarvan kan niet worden hersteld."],
            persistent: true,
          },
      )) {
        return
      }
      this.$goto("category.destroy", { category_id: this.category.id })
    },
    openSubcategory (subcategory) {
      this.$goto("category.subcategory.edit", { category: this.category.id, subcategorie: subcategory.id })
    },
  },
}
</script>
